import instance from './interceptor';
import {getEnv} from './environments';

const Endpoints = {
    // auth
    auth: (payload, callback) => pushAuth('post', '/token', payload, callback), 
    refreshToken: (payload, callback) => pushAuth('post', '/token/refresh', payload, callback), 
    getUser: (callback) => pushApi('get', '/user', {}, callback), 

    // companies
    getCompanyType: (userId, callback, error_callback) => pushApi('get', `/users/${userId}/company-type`, null, callback, error_callback),
    getUserCompanies: (payload, callback) => pushApi('get', `/user-affiliations/${payload.id}`, {}, callback),
    updateCompanyDetails: (payload, callback) => pushApi('put', `/company`, payload, callback),

    // Registrations
    registerUser: (payload, callback, error_callback) => pushApi('post', '/users', payload, callback, error_callback),
    registerCompany: (payload, callback) => pushApi('post', '/companies', payload, callback),

    // Pending Applications
    getPendingApplications: (callback) => pushApi('get', '/companies?is_confirmed=0', {}, callback),
    updateCompany: (payload, callback) => pushApi('put', `/company/${payload.id}`, payload, callback),
    deleteCompany: (payload, callback) => pushApi('delete', `/company/${payload.type}/${payload.id}`, {}, callback),

    // product group
    getProductGroups: (callback) => pushApi('get', '/productgroups', {}, callback),

    // Brands
    createBrand: (payload, callback) => pushApi('post', '/brands', payload, callback),
    getBrand: (payload, callback) => pushApi('get', `/brand/${payload.shortname}?sessionUser=${payload.sessionUser}`, payload, callback),
    updateBrandMarket: (brandID, payload, callback) => pushApi('put', `/brand/${brandID}/market`, payload, callback),
    updateBrand: (payload, callback) => pushApi('put', `/brands/${payload.id}`, payload, callback),
    updateBrandAgent: (payload, callback) => pushApi('put', `/brand/${payload.id}/agent`, payload, callback),
    deleteBrand: (brandId, callback, error_callback) => pushApi('delete', `/brands/${brandId}`, {}, callback, error_callback),

    // Agency
    getAgency: (payload, callback) => pushApi('get', `/agency/${payload.shortname}?sessionUser=${payload.sessionUser}`, payload, callback),
    updateAgencyAvailabilityStatus: ( agencyID, payload, callback ) => pushApi( 'put', `/agency/${agencyID}/availability-status`, payload, callback ),
    updateAboutDetails: ( agencyID, payload, callback ) => pushApi( 'put', `/agency/${agencyID}/about`, payload, callback ),
    updateAgencyMarket: ( agencyID, payload, callback ) => pushApi( 'put', `/agency/${agencyID}/market`, payload, callback ),
    updateAgencyHowYouWork: ( agencyID, payload, callback ) => pushApi( 'put', `/agency/${agencyID}/how-you-work`, payload, callback ),
    updateAgencyBrandExperience: ( agencyID, payload, callback ) => pushApi( 'put', `/agency/${agencyID}/brand-experience`, payload, callback ),
    updateAgencySalesDetails: ( agencyID, payload, callback ) => pushApi( 'put', `/agency/${agencyID}/sales-details`, payload, callback ),

    // Carousel
    getCarouselMatches: (payload, callback, error_callback) => pushApi('get', `/carousel/matches?sessionUser=${payload.sessionUser}&userType=${payload.userType}`, {}, callback, error_callback),
    getCarouselMatchesWithScoring: (payload, callback, error_callback) => pushApi('get', `/carousel/matches-scored?sessionUser=${payload.sessionUser}&userType=${payload.userType}&limit=${payload.limit || 10}`, {}, callback, error_callback),
    
    // Favorites
    addToFavorites: (payload, callback) => pushApi('post', '/add-to-faavorites', payload, callback),
    getFavorites: (payload, callback) => pushApi('get', `/favorites?owner=${payload.owner}&owner_id=${payload.owner_id}`, {}, callback),
    getBlacklist: (payload, callback) => pushApi('get', `/favorites?owner=${payload.owner}&owner_id=${payload.owner_id}&preference=blacklist`, {}, callback),
    toggleFavorite: (payload, callback) => pushApi('post', '/add-to-favorites', {...payload, preference: 'favorite'}, callback),
    toggleBlacklist: (payload, callback) => pushApi('post', '/add-to-favorites', {...payload, preference: 'blacklist'}, callback),

    // File Upload
    uploadAttachment: (payload, callback) => pushUpload('post', '/attachments', payload, callback),
    updateAttachment: (payload, callback) => pushUpload('post', `/attachment/${payload.id}`, payload, callback),
    getUploadUrl: () => { return getEnv('API_URI')+'storage' },
    deleteAttachment: (id, callback) => pushApi( 'delete', `/attachment/${id}`, {}, callback ),

    // Contacts
    requestContact: (payload, callback) => pushApi('post', '/contact-requests', payload, callback),

    // Search
    search: (payload, callback) => pushApi('get', `/search?${payload.params}`, {}, callback),
    // search: (payload, callback) => { console.log(payload) },
    
    // Regions - Candidate for obsolete
    getRegions: (callback) => pushApi('get', `/region`, {}, callback),

    // Form Options
    getFormoptions: (callback) => pushApi('get', `/formoptions`, {}, callback),

    //Forgot Password
    forgotPassword: (payload, callback, error_callback) => pushApi('post', '/forgot/password', payload, callback, error_callback),
    resetPassword: (payload, callback, error_callback) => pushApi('post', '/reset/password', payload, callback, error_callback),

    changePassword: ( payload, callback, finally_callback ) => pushApi( 'post', `/change-password`, payload, callback, () => {}, finally_callback ),

    //Public view brand
    getViewBrand: (payload, callback) => pushApi('get', `/view-brand/${payload.shortname}`, payload, callback),

    //Public view agency
    getViewAgency: (payload, callback) => pushApi('get', `/view-agency/${payload.shortname}`, payload, callback),
}

const pushApi = ( action, route, payload, callback, error_callback=()=>{}, finally_callback=()=>{} ) => {
    instance[action](`api${route}`, payload)
    .then( ( res ) => {
        callback( res );
    } )
    .catch( ( error ) => {
        error_callback( error );
    } )
    .finally( () => {
        finally_callback();
    } );
}

const pushAuth = (action, route, payload, callback) => {
    instance[action](`oauth${route}`, payload)
    .then((res) => {
        callback(res);
    })
    .catch((err) => {
        // Format error response to include status and data
        callback({
            status: err.response.status,
            data: err.response.data
        });
    });
};

const pushUpload = (action, route, payload, callback) => {
    instance[action](`api${route}`, payload, {
        headers: {
            "Content-Type": "multipart/form-data",
        }
    })
    .then((res) => {
        callback(res);
    });
}

export default Endpoints;